<ul class="list">
  <ng-container *ngFor="let serverName of serverNames" [ngSwitch]="serverName">
    <li *ngSwitchCase="'tp'" class="item item--icon">
      <img src="./assets/img/icons/i-fbs-trader.svg" alt="FBS Trader">
    </li>
    <li *ngSwitchCase="'ct'" class="item item--icon">
      <img src="./assets/img/copytrade-logo.svg" alt="FBS Copytrade">
    </li>
    <ng-container *ngSwitchCase="''"></ng-container>
    <li *ngSwitchDefault class="item">
      {{ serverName | uppercase }}
    </li>
  </ng-container>
</ul>
